export const InsuranceExcessFeeTypes = {
  Percentage: 'PERCENTAGE',
  FlatSum: 'FLAT_SUM',
} as const

export type InsuranceExcessFeeType =
  (typeof InsuranceExcessFeeTypes)[keyof typeof InsuranceExcessFeeTypes]

export const INSURANCE_EXCESS_FEE_TYPE_VALUES = Object.values(
  InsuranceExcessFeeTypes,
) as [InsuranceExcessFeeType, ...InsuranceExcessFeeType[]]
